const ISO_RE = /^(\d{4})-(\d{2})-(\d{2})$/

const pad2 = (n: number) => (n < 10 ? `0${n}` : String(n))

export const toIsoDate = (d: Date): string =>
  `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`

export const parseIsoDate = (raw: string | null | undefined): Date | null => {
  if (!raw) return null
  const match = ISO_RE.exec(raw)
  if (!match) return null
  const y = Number(match[1])
  const m = Number(match[2])
  const d = Number(match[3])
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null
  const date = new Date(y, m - 1, d)
  if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) return null
  return date
}
